import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ContentSections from './components/ContentSections';
import Footer from './components/Footer';

function HomeSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        'name': 'Sugargoo Spreadsheet Resource Hub',
        'url': 'https://sugargoosheet.it.com/',
        'description': 'The most complete Sugargoo Spreadsheet resource hub with curated product finds, expert reviews, shipping cost guides, discount codes, warehouse information, and smart shopping tips for global buyers.',
        'potentialAction': {
          '@type': 'SearchAction',
          'target': 'https://sugargoosheet.it.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        'name': 'Sugargoo Sheet',
        'url': 'https://sugargoosheet.it.com/',
        'logo': {
          '@type': 'ImageObject',
          'url': 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
        },
        'sameAs': [
          'https://kaspreadsheet.com',
        ],
      },
      {
        '@type': 'WebPage',
        'name': 'Sugargoo Spreadsheet - Best Finds, Reviews, Shipping Guide & Deals',
        'description': 'Discover the ultimate Sugargoo Spreadsheet resource with curated product finds, expert reviews, shipping cost guides, discount codes, warehouse information and smart shopping tips for global buyers.',
        'url': 'https://sugargoosheet.it.com/',
        'isPartOf': {
          '@type': 'WebSite',
          'name': 'Sugargoo Spreadsheet Resource Hub',
          'url': 'https://sugargoosheet.it.com/',
        },
        'primaryImageOfPage': {
          '@type': 'ImageObject',
          'url': 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
        },
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export default function Home() {
  return (
    <>
      <HomeSchema />
      <main>
        <Navbar />
        <HeroSection />
        <CategoryGrid />
        <ContentSections />
        <Footer />
      </main>
    </>
  );
}